// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    dailySaleList: [],
    totalRows: 0,
    rowsPerPage: 5,
    page: 0,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'dailySalesReport',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setDailySales(state, action) {
            state.dailySaleList = action.payload;
        },
        setDailySaleRowPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setDailySalePage(state, action) {
            state.page = action.payload;
        },
        setTotalRows(state, action) {
            state.totalRows = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;
export const { setDailySaleRowPerPage, setDailySalePage } = slice.actions;
// ----------------------------------------------------------------------

export function getDailySales(data) {
    return async () => {
        try {
            const response = await axios.post('/reports/daily-sales', data);
            if (response.data.status) {
                dispatch(slice.actions.setDailySales(response.data.data));
                dispatch(slice.actions.setTotalRows(response.data.total_rows));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
